const clearAllSelectedVehiclesDataPush = () => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "clear-all",
        action: "clear-all",
        section: "pop-up",
      },
    });
  }
};

export default clearAllSelectedVehiclesDataPush;
